import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteMembershipVehicleSlice = createSlice({
  name: "DeleteMembershipVehicle",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteMembershipVehicle: (state, _) => {
      state.isLoading = true;
    },
    successDeleteMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteMembershipVehicle: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteMembershipVehicle,
  failureDeleteMembershipVehicle,
  successDeleteMembershipVehicle,
  clearDeleteMembershipVehicle,
} = DeleteMembershipVehicleSlice.actions;

export default DeleteMembershipVehicleSlice.reducer;
